module.exports = __webpack_public_path__ + "img/win.624958bf.svg";